<template>
	<div id="app">
		<router-view></router-view>
    <fudong v-if="show"></fudong>
	</div>
</template>

<script>
  import fudong from '@/components/fudong.vue'
  export default {
    name: 'App',
    components:{
      fudong
    },
    data() {
      show:true
    },
    mounted() {
      if(location.href.includes('xiazai2')){
        this.show = false
      }
    }
  }
</script>

<style lang="less">
	@import "~@/assets/all.less";
</style>



// WEBPACK FOOTER //
// src/App.vue